.container {}
.description {
  max-width: 40rem;
}

.input {
  display: block;
  width: 24rem;
  margin: 12px 0;
  padding: 4px 8px;
  font-family: monospace;
  font-size: 1.1rem;
}

.error {
  color: var(--error-color);
  font-weight: bold;
}

.pools {
  font-family: monospace;
}

.resultsTable {
  border-collapse: collapse;

  th, td {
    border: 1px solid var(--border-color);
    padding: 4px 12px;
    text-align: left;
  }

  th:last-child, td:last-child {
    text-align: right;
  }
}

.mod {
  display: inline-block;
  margin: 1px 2px;
  padding: 0 4px;
  border: 1px solid #99999955;
  border-radius: 3px;
  font-family: monospace;
}

.exclusive {
  border-color: var(--exclusive-border);
  background: var(--exclusive-background);
  color: var(--exclusive-text);
}

.aspect {
  border-color: var(--aspect-border);
  background: var(--aspect-background);
  color: var(--aspect-text);
}

.crafted {
  border-color: var(--crafted-border);
  background: var(--crafted-background);
  color: var(--crafted-text);
}

.checkbox {
  display: block;
  margin: 8px 0;
}
